import { jsx } from 'react/jsx-runtime';
import { ErrorBoundary } from 'react-error-boundary';
import { useErrorHandler } from '../ErrorContext.js';

const SentryErrorBoundary = ({ children, fallbackRender, }) => {
    const errorHandler = useErrorHandler();
    const fallbackRenderNullSafe = fallbackRender ??
        (({ error, resetErrorBoundary }) => {
            console.error(error);
            return null;
        });
    const handleError = (error) => {
        errorHandler.captureException(error);
    };
    return (jsx(ErrorBoundary, { fallbackRender: fallbackRenderNullSafe, onError: handleError, children: children }));
};

export { SentryErrorBoundary as default };
//# sourceMappingURL=SentryErrorBoundary.js.map
